import { inject, Injectable } from '@angular/core';
import { catchError, filter, map, Observable, of, shareReplay, tap } from 'rxjs';
import { SessionType } from '@core/types';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { ANONYMOUS, CACHE_SIZE } from '@core/constants';
import { userIsAuthenticated } from '@core/helpers/auth';

@Injectable({
  providedIn: 'root',
})
export class CyloginService {
  private readonly httpClient = inject(HttpClient);
  private _session$?: Observable<SessionType>;

  public isAuthenticated(ignoreCache: boolean = false): Observable<boolean> {
    return this.getSession(ignoreCache).pipe(map(userIsAuthenticated));
  }

  public getSession(ignoreCache: boolean = false) {
    const headers = new HttpHeaders({
      'X-CSRF': '1',
    });
    if (!this._session$ || ignoreCache) {
      this._session$ = this.httpClient.get<SessionType>('bff/user', { headers }).pipe(
        // tap(session => {
        //   let logoutUrl = session?.find((c, i) => c.type === 'bff:logout_url' );
        //   if (logoutUrl?.value) {
        //     sessionStorage.setItem('logout_url', logoutUrl.value)// + '&returnUrl=/api/logged-out');
        //   }
        // }),
        catchError((err) => {
          return of(ANONYMOUS);
        }),
        shareReplay(CACHE_SIZE)
      );
    }
    return this._session$;
  }

  public getSessionClaim(claim: string, ignoreCache: boolean = false) {
    return this.getSession(ignoreCache).pipe(
      filter(userIsAuthenticated),
      map(
        (sessionClaims) => sessionClaims.find((sessionClaim) => sessionClaim.type === claim)?.value
      )
    );
  }
}
